"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoCompleteAddressButton = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../../styles");
var Button = styled_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  padding: 8px 16px;\n  font-size: 16px;\n  line-height: 1.5;\n  color: ", ";\n  background: #f0f0f0;\n  border: 1px solid ", ";\n  min-width: 144px;\n  border-radius: 4px;\n  min-height: 40px;\n"], ["\n  ", "\n  padding: 8px 16px;\n  font-size: 16px;\n  line-height: 1.5;\n  color: ", ";\n  background: #f0f0f0;\n  border: 1px solid ", ";\n  min-width: 144px;\n  border-radius: 4px;\n  min-height: 40px;\n"])), styles_1.MixinButtonStyle, styles_1.COLOR.font.base, styles_1.COLOR.border.base);
var AutoCompleteAddressButton = function (_a) {
    var className = _a.className, onClick = _a.onClick, label = _a.label, disabled = _a.disabled;
    return (react_1.default.createElement(Button, { type: "button", className: className, onClick: onClick, disabled: disabled, "data-cy-search-address-button": true }, label));
};
exports.AutoCompleteAddressButton = AutoCompleteAddressButton;
var templateObject_1;
